var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLootboxRewardsArrow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 66,
    height: 66,
    rx: 33,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4477 22.834C38.1276 22.834 38.9689 24.8651 37.781 26.0529L31.0404 32.7935C30.6499 33.1841 30.6499 33.8172 31.0404 34.2078L37.7811 40.9484C38.9689 42.1362 38.1276 44.1673 36.4477 44.1673C35.9476 44.1673 35.468 43.9687 35.1144 43.615L26.4142 34.9149C25.6332 34.1338 25.6332 32.8675 26.4142 32.0864L35.1144 23.3863C35.468 23.0326 35.9476 22.834 36.4477 22.834Z",
    fill: "#143478"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLootboxRewardsArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lootbox-rewards-arrow.0bb33c7d2fba89b195c0abbf71c64820.svg";